import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Supabase redirects here after Google OAuth completes.
// AuthContext's onAuthStateChange fires automatically when the session is set,
// so we just need to wait for the user to be populated, then navigate.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { user, loading, needsUsername } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (user) {
      if (needsUsername) {
        navigate('/choose-username', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } else {
      // No session after callback — something went wrong
      navigate('/login?error=1', { replace: true });
    }
  }, [user, loading, needsUsername, navigate]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 16, color: '#8a909e' }}>
      <div className="queue-spinner" />
      <p>Signing you in…</p>
    </div>
  );
}
